import {createContext} from 'react'
import type {BannerProps} from '@primer/react'

/**
 * The input shape accepted by `addBanner`/`updateBanner`:
 */
export interface BannerInput extends BannerProps {
  dismissible?: boolean
}

/** A banner supplied when the provider first renders, with an SSR-stable id. */
export interface InitialBanner extends BannerInput {
  id: string
}

/** A banner as tracked internally, with its generated stable `id`. */
export type BannerData = InitialBanner

export interface InternalBannerStackDataContextValue {
  banners: BannerData[]
}

export const InternalBannerStackDataContext = createContext<InternalBannerStackDataContextValue>({
  banners: [],
})
